import { PriorityStockItem } from "../common/PriorityStockItem";
import { PriorityStockLineItem } from "../pages/Receiving/types";

export function sortArrayByFirstValue(arrayToSort, sortOrder) {
	return arrayToSort.sort((a, b) => {
		const aSortIndex = sortOrder.indexOf(a[0]);
		const bSortIndex = sortOrder.indexOf(b[0]);
		return aSortIndex - bSortIndex;
	});
}

export function sortArrayByStatus(arrayToSort, sortOrder) {
	return arrayToSort.sort((a, b) => {
		const aSortIndex = sortOrder.indexOf(a.status);
		const bSortIndex = sortOrder.indexOf(b.status);
		return aSortIndex - bSortIndex;
	});
}

export function sortItemsByPriorityStockFlag(
	items: Array<PriorityStockLineItem>,
	flatPriorityStock: Array<PriorityStockItem>
) {
	const priorityStockMap = new Map(flatPriorityStock.map((ps) => [ps.sku, ps]));

	const receivedQuantity = (li: PriorityStockLineItem) => {
		if (li.received !== undefined) return li.received;

		if (li.receivedQuantity !== undefined) return li.receivedQuantity;

		return 0;
	};

	return items.sort((a, b) => {
		/* Sort ordering priority: 
			1) Show scanned items at the top of the list, ordered by their timestamp descending
			2) Order by priority flags
			3) Default to timestamp descending
		 */

		// Items that are received get the highest priority
		if (receivedQuantity(a) > 0 && receivedQuantity(b) <= 0) return -1;
		if (receivedQuantity(b) > 0 && receivedQuantity(a) <= 0) return 1;

		// If both received order by timestamp
		if (receivedQuantity(a) > 0 && receivedQuantity(b) > 0) {
			const aTimestamp = a.modifiedTimestamp ? a.modifiedTimestamp.getTime() : 0;
			const bTimestamp = b.modifiedTimestamp ? b.modifiedTimestamp.getTime() : 0;
			return bTimestamp - aTimestamp; // Descending order by date modified
		}

		const aPriorityStock = priorityStockMap.get(a.sku);
		const bPriorityStock = priorityStockMap.get(b.sku);

		// Order by the priority of the SKU, if set
		if (aPriorityStock && bPriorityStock) {
			if (aPriorityStock.priority !== bPriorityStock.priority) {
				return aPriorityStock.priority - bPriorityStock.priority;
			}
		}

		if (aPriorityStock && !bPriorityStock) return -1;
		if (!aPriorityStock && bPriorityStock) return 1;

		// Default order by their timestamp
		const aTimestamp = a.modifiedTimestamp ? a.modifiedTimestamp.getTime() : 0;
		const bTimestamp = b.modifiedTimestamp ? b.modifiedTimestamp.getTime() : 0;

		return bTimestamp - aTimestamp;
	});
}

export function sortItemsByModifiedDesc(items) {
	items.sort((a, b) => {
		if (a.modifiedTimestamp === undefined) {
			a.modifiedTimestamp = new Date(0);
		}
		if (b.modifiedTimestamp === undefined) {
			b.modifiedTimestamp = new Date(0);
		}
		return b.modifiedTimestamp - a.modifiedTimestamp;
	});
}
